import { useMemo } from "react";
import { useAppSseClient, type SseHandlers } from "@/hooks/appSseClientHook";
import {
  SPACE_CARD_UPDATED,
  SPACE_PRESENCE_CHANGED,
} from "@/constants/appSSEEventTypes";
import type {
  SpaceCardUpdatedPayload,
  SpacePresenceChangedPayload,
} from "./spacesSSEEventPayloadTypes";

export type { SpaceCardUpdatedPayload, SpacePresenceChangedPayload };

type SpacesStreamHandlers = {
  onSpaceCardUpdated?: (payload: SpaceCardUpdatedPayload) => void;
  onSpacePresenceChanged?: (payload: SpacePresenceChangedPayload) => void;
};

export function useSpacesEventStream(
  enabled: boolean,
  handlers: SpacesStreamHandlers,
): void {
  // Stable handler map — identity is recalculated only when the callbacks change.
  const sseHandlers = useMemo<SseHandlers>(
    () => ({
      [SPACE_CARD_UPDATED]: (data) =>
        handlers.onSpaceCardUpdated?.(data as SpaceCardUpdatedPayload),
      [SPACE_PRESENCE_CHANGED]: (data) =>
        handlers.onSpacePresenceChanged?.(data as SpacePresenceChangedPayload),
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }),
    [handlers.onSpaceCardUpdated, handlers.onSpacePresenceChanged],
  );

  useAppSseClient(enabled, sseHandlers);
}
